import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import { Button, Modal, Table } from "../../../components/core";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import { ALL_OPERATOR_ACCOUNT_ROLES } from "../../../constants/graphql/operator_account_roles";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { paginatorTemplate } from "../settings-coins/components/paginatorTemplate";
import { Column } from "primereact/column";
import { formatDate } from "../../../algorithms/date";
import { Button as PrimereactButton } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { DELETE_OPERATOR_ROLE_MUTATION } from "../../../constants/graphql/account-roles";
import { Strings } from "../../../constants/strings";
import TotalRecords from "../../../components/core/total-records";
import { useSelector } from "react-redux";
import useSidebarStore from "../../../zustand/stores/sidebar-store";

export default function RolesAndTemplates() {
  const navigate = useNavigate();
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );

  // local states
  const [operatorAccountRoles, setOperatorAccountRoles] = React.useState([]);
  const [deleteModalObj, setDeleteModelObj] = React.useState({
    open: false,
    operatorAccountRoleId: "",
  });
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });
  const [changesMade, setChangesMade] = useState(false);
  // gql
  const allOperatorAccountRoles = useQuery(ALL_OPERATOR_ACCOUNT_ROLES, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
    fetchPolicy: "no-cache",
  });
  const [deleteOperatorAccountRole] = useMutation(
    DELETE_OPERATOR_ROLE_MUTATION
  );

  // use Effects
  React.useEffect(() => {
    if (allOperatorAccountRoles.data) {
      console.log({ data: allOperatorAccountRoles.data });
      let tempArr = [];
      allOperatorAccountRoles.data.allOperatorAccountRoles.forEach(
        (element) => {
          let tempElement = { ...element };

          tempArr.push(tempElement);
        }
      );
      setOperatorAccountRoles(tempArr);
    }
  }, [allOperatorAccountRoles.data]);

  const deleteRole = () => {
    deleteOperatorAccountRole({
      variables: {
        operatorAccountRoleId: deleteModalObj.operatorAccountRoleId,
      },
    })
      .then((response) => {
        if (response) {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
            title: Strings.popup_success_title_default,
            message: Strings.popup_success_message_remove,
            open: true,
            actions: (
              <Button
                onClick={() => {
                  setValidation({ open: false });
                  window.location.reload();
                }}
                value={"OK"}
                className={"p-2 w-full"}
              />
            ),
          });
        }
      })
      .catch((error) => {
        console.error({ error });
        if (error) {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: Strings.popup_error_title,
            message: Strings.popup_error_message_remove,
            open: true,
            actions: (
              <Button
                onClick={() => {
                  setValidation({ open: false });
                }}
                value={"OK"}
                className={"p-2 w-full"}
              />
            ),
          });
        }
      });
  };

  console.log({ operatorAccountRoles });
  return (
    <ContentContainer containerTitle={"Roles and Templates"}>
      <div>
        <Button
          value={"Add template"}
          className={`p-2 ml-auto ${
            accessPermission.rolesAndTemplates === 1 ||
            accessPermission.rolesAndTemplates === "1"
              ? "hidden"
              : ""
          }`}
          // onClick={() => navigate("add-template")}
          onClick={() => {
            window.open(
              `${process.env.REACT_APP_BASE_ENVIRONMENT}roles-and-templates/add-template`,
              "_blank"
            );
          }}
        />
      </div>

      <Card>
        {/* <Table
					items={operatorAccountRoles}
					headers={[
						{ header_key: "roleName", header_name: "Role Name" },
						{
							header_key: "createdAt",
							header_name: "Date Created",
							tag: "date",
						},
					]}
					className={"w-full"}
					fieldId={"operatorAccountRoleId"}
					actionEdit={(rowData) => {
						navigate(`edit-template/${rowData.operatorAccountRoleId}`);
					}}
				/> */}
        <TotalRecords count={operatorAccountRoles.length} />

        <DataTable
          value={operatorAccountRoles}
          showGridlines
          stripedRows
          paginator
          multiple
          removableSort
          sortMode="multiple"
          rows={10}
          rowHover={false}
          emptyMessage="No roles found"
          paginatorTemplate={paginatorTemplate}
        >
          <Column
            headerClassName="bg-primary-primaryYellow "
            // alignHeader={"center"}
            header="Role Name"
            sortable
            field="roleName"
            // className="text-center"
          />
          <Column
            headerClassName="bg-primary-primaryYellow "
            // alignHeader={"center"}
            header="Date Created"
            sortable
            field="createdAt"
            // className="text-center"
            body={(rowData) => {
              return (
                <>
                  <div>{formatDate(rowData.createdAt)}</div>
                </>
              );
            }}
          />

          <Column
            headerClassName="bg-primary-primaryYellow "
            // alignHeader={"center"}
            header="Date Updated"
            sortable
            field="updatedAt"
            // className="text-center"
            body={(rowData) => {
              return (
                <>
                  <div>{formatDate(rowData.updatedAt)}</div>
                </>
              );
            }}
          />
          <Column
            headerClassName="bg-primary-primaryYellow text-center"
            alignHeader={"center"}
            header=""
            field="action"
            // className="text-center"
            body={(rowData) => {
              return (
                <div className="flex gap-3 items-center justify-center">
                  <PrimereactButton
                    // value={"Edit"}
                    // icon={`}`}
                    icon={` ${
                      accessPermission.rolesAndTemplates === 1 ||
                      accessPermission.rolesAndTemplates === "1"
                        ? "pi pi-eye"
                        : "pi pi-pencil"
                    }`}
                    className="bg-primary-primaryYellow text-black border-0 px-4 py-1 font-semibold"
                    onClick={() => {
                      // navigate(
                      // 	`edit-template/${rowData.operatorAccountRoleId}`
                      // );
                      window.open(
                        `${process.env.REACT_APP_BASE_ENVIRONMENT}roles-and-templates/edit-template/${rowData.operatorAccountRoleId}`,
                        "_blank"
                      );
                    }}
                  >
                    {/* Edit */}
                  </PrimereactButton>

                  <PrimereactButton
                    // icon={`}`}
                    disabled={
                      rowData.operator === "19" ||
                      rowData.operatorAccountRoleId === 19 ||
                      rowData.roleName === "Super Admin"
                    }
                    icon="pi pi-trash"
                    className={`bg-red-400 text-black border-0 px-4 py-1 ${
                      accessPermission.rolesAndTemplates === 1 ||
                      accessPermission.rolesAndTemplates === "1"
                        ? "hidden"
                        : ""
                    }`}
                    onClick={() => {
                      let tempData = { ...rowData };
                      delete tempData.operator;
                      console.log(tempData.active);
                      setDeleteModelObj({
                        ...tempData,
                        open: true,
                        operatorAccountRoleId: tempData.operatorAccountRoleId,
                        operatorAccountId: tempData.operatorAccountId,
                        // active: tempData.active === "Active" ? "1" : "0",
                      });
                    }}
                  ></PrimereactButton>
                </div>
              );
            }}
          />
        </DataTable>
      </Card>

      <Dialog
        visible={deleteModalObj.open}
        // onHide={() => setAddModelObj((prev) => ({ ...prev, open: false }))}
        onHide={() =>
          setDeleteModelObj({
            ...deleteModalObj,
            open: false,

            operatorAccountRoleId: "",
          })
        }
        header={
          <div className="flex flex-col items-center justify-center">
            <img
              alt="cancel-icon"
              className="h-[90px] mr-2"
              src="https://files.axshare.com/gsc/WVWZ57/33/6d/24/336d246d351f4c1fa96b79e22e01b267/images/define_doors/u29.png?pageId=a40ab7eb-ce47-459a-9061-03fbe05c510f"
            />
            {/* <div className="font-bold">{`Delete Confirmation`}</div> */}
          </div>
        }
        style={{ overflowY: "auto" }}
        closable={false}
        draggable={false}
        className="w-[480px]"
      >
        <div>
          {/* <div className="my-4 grid grid-cols-2 gap-4"> */}
          <div className="text-lg text-center">
            Are you sure you want to delete this role:
            <span className="font-semibold text-orange-400">
              {" "}
              {deleteModalObj.roleName}
            </span>
            ?
          </div>

          <div className="pt-3 ">
            <div className="flex gap-2 w-full items-center justify-center">
              <PrimereactButton
                size="small"
                className="bg-white text-black  border border-primary-primaryYellow px-4 py-2 hover:bg-slate-100"
                onClick={() => {
                  setDeleteModelObj({ open: false });
                }}
              >
                Cancel
              </PrimereactButton>
              <PrimereactButton
                size="small"
                className="bg-primary-primaryYellow text-black border-0 hover:bg-primary-primaryYellowDark px-4 py-2"
                // disabled={isClicked}
                onClick={(e) => {
                  deleteRole(deleteModalObj);
                }}
                label="Confirm"
              ></PrimereactButton>
            </div>
          </div>
        </div>
      </Dialog>

      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </ContentContainer>
  );
}
